module.exports = __webpack_public_path__ + "static/img/platphom1.8f269e1f.png";